export interface PaymentInstructions {
  swift: dataItem[]
  ach: dataItem[]
}

interface dataItem {
  key: string
  value: string
}

export const PaymentInstructionsProd: PaymentInstructions[] = [
  {
    swift: [
      {
        key: 'Destination Bank/Account with Institution:',
        value: 'Royal Bank of Canada, Toronto, ON'
      },
      { key: 'SWIFT BIC', value: 'ROYCCAT2' },
      { key: 'Beneficiary Account Number:', value: '027221107879' },
      { key: 'Bank Code:', value: '003' },
      { key: 'Branch/Transit Number:', value: '02722' },
      { key: 'Beneficiary Name:', value: 'VERSABANK' }
    ],
    ach: [
      { key: 'Name:', value: 'VERSABANK' },
      { key: 'Bank Transit:', value: '02722' },
      { key: 'Bank Code:', value: '003' },
      { key: 'Account Number:', value: '1107879' }
    ]
  }
]
export const PaymentInstructionsDummy: PaymentInstructions[] = [
  {
    swift: [
      { key: 'Destination Bank/Account with Institution:', value: 'QCAD Digital Trust (Test)' },
      { key: 'SWIFT BIC', value: 'TESTCODE' },
      { key: 'Beneficiary Account Number:', value: '1234567890' },
      { key: 'Bank Code:', value: '000' },
      { key: 'Branch/Transit Number:', value: '12345' },
      { key: 'Beneficiary Name:', value: 'QCAD Digital Trust (Test)' }
    ],
    ach: [
      { key: 'Name:', value: 'QCAD Digital Trust (Test)' },
      { key: 'Bank Transit:', value: '12345' },
      { key: 'Bank Code:', value: '000' },
      { key: 'Account Number:', value: '1234567890' }
    ]
  }
]
